var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[_c('skeleton-loader',{attrs:{"type":"rect","width":200,"height":20,"animation":"fade"}}),_c('skeleton-loader',{staticClass:"mt-4",attrs:{"type":"rect","width":100,"height":30,"animation":"fade"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }